/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ResourceRepository } from '@common/tech-shared';
import { VorgangService } from '@alfa-client/vorgang-shared';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ExterneFachstelleResourceSearchService,
  createExterneFachstelleResourceSearchService,
} from './externe-fachstelle/externe-fachstelle-resource-search.service';
import { ExterneFachstelleService } from './externe-fachstelle/externe-fachstelle.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    ExterneFachstelleService,
    {
      provide: ExterneFachstelleResourceSearchService,
      useFactory: createExterneFachstelleResourceSearchService,
      deps: [ResourceRepository, VorgangService],
    },
  ],
})
export class ZustaendigeStelleSharedModule {}
